module.exports = __webpack_public_path__ + "static/media/ALLYGN_LOGO_SMALL.81695ab3.svg";